import React from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText, SxProps, Typography, Theme } from '@mui/material';

export interface FormNavItemProps {
  title: string;
  value: number;
  selectedValue: number;
  onClick: (value: number) => void;
  icon?: React.ReactNode;
  disabled?: boolean;
  slots?: {
    listItemIcon?: {
      sx?: SxProps<Theme>;
    };
  };
}

const VerticalTab = ({ title, onClick, value, selectedValue, icon, slots, disabled }: FormNavItemProps) => {
  const isSelected = selectedValue === value;

  return (
    <ListItem
      disablePadding={true}
      sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
      data-cy={`vertical-tab-${title}`}
    >
      <ListItemButton
        selected={isSelected}
        onClick={() => onClick(value)}
        role="tab"
        aria-label={title}
        disabled={disabled}
        sx={{
          py: 1.5,
          borderLeft: '4px solid',
          borderLeftColor: isSelected ? 'primary.main' : 'transparent',
          '&:hover': { bgcolor: 'action.hover' },
          '&.Mui-selected': {
            bgcolor: 'action.selected',
            '&:hover': {
              bgcolor: 'action.selected',
            },
          },
        }}
      >
        <ListItemText>
          <Typography sx={{ fontWeight: isSelected ? 'bold' : 'normal' }}>{title}</Typography>
        </ListItemText>
        {icon && <ListItemIcon sx={slots?.listItemIcon?.sx}>{icon}</ListItemIcon>}
      </ListItemButton>
    </ListItem>
  );
};

export default VerticalTab;
